import apollo from '@/graphql'

// import PogsQuery from '@/graphql/pog/PogsQuery.gql'
import PaginationPogsQuery from '@/graphql/pog/PaginationPogsQuery.gql'

// initial state
const state = {
  loading: false,
  pogs: [],
  total: 0,
}

// getters
const getters = {
  pogs: st => st.pogs,
}

// mutations
const mutations = {
  setPogs(state, pogs) {
    state.pogs = pogs
  },
  setLoading(state, loading) {
    state.loading = loading
  },
  setTotal(state, total) {
    state.total = total
  },
}

// actions
const actions = {
  async load({ commit }, { page, pageSize, search, sortField, sortType }) {
    const mappingSortField = {
      name: 'name',
      rackType: 'rack_types_id',
      effectiveDate: 'effective_date',
      deactivateDate: 'deactivate_date',
      uploadTime: 'upload_time',
      retailer: 'companies_id',
    }

    commit('setLoading', true)
    const { data: { paginationPogs: { pogs, pagination } } } = await apollo.defaultClient.query({
      query: PaginationPogsQuery,
      variables: { page, pageSize, search, sortField: `pogs.${mappingSortField[sortField]}`, sortType },
    })
    commit('setPogs', pogs)
    commit('setLoading', false)
    commit('setTotal', pagination.total)
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}



// WEBPACK FOOTER //
// ./src/store/modules/pog/PogList.js